import { Doughnut } from "react-chartjs-2"
import { Chart, registerables } from "chart.js"
import configs from "./configs"
Chart.register(...registerables)

function DoughnutChart({ chart }) {
    const { data, options } = configs(chart.labels || [], chart.datasets || {})

    return (
        <div style={{
            width: "100%",
            height: 350,
            minHeight: 300,
            maxWidth: 500,
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <Doughnut
                data={data}
                options={{
                    ...options,
                    responsive: true,
                    maintainAspectRatio: false
                }}
            />
        </div>
    )
}

export default DoughnutChart